import clsx from 'clsx'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'
import { Shimmer } from '@wartek-id/shimmer'

import SchoolItemBadge from 'app/KinerjaKSPage/components/School/SchoolItemBadge'
import { type School } from 'types/kinerja-ks'
import { RoleLabel } from 'app/KinerjaKSPage/utils/profile'

import type { SchoolItemBadgeProps } from 'app/KinerjaKSPage/components/School/SchoolItemBadge'
import type { FC } from 'react'

interface SchoolItemProps {
  isLoading?: boolean
  disabled?: boolean
  data?: School
  badgeStatus?: SchoolItemBadgeProps['status']
  onClick?: () => void
}

const SchoolItem: FC<SchoolItemProps> = ({
  isLoading = false,
  disabled = false,
  data,
  badgeStatus,
  onClick,
}) => {
  // Displayed if School is loading
  if (isLoading) {
    return (
      <div className="border-subdued border-solid border rounded bg-white px-6 py-4 flex items-center gap-2">
        <div className="flex flex-col gap-2 flex-1">
          <Shimmer width={250} height={22} />
          <Shimmer width={150} height={20} />
          <Shimmer width={128} height={22} className="!rounded-3xl" />
        </div>

        <Shimmer width={36} height={36} rounded />
      </div>
    )
  }

  // Displayed if School has finished loading
  return (
    <div className="border-subdued border-solid border rounded bg-white px-6 py-4 flex items-center gap-2">
      <div className="flex flex-col gap-2 flex-1">
        <Text variant="heading-sm">{data?.schoolName || '-'}</Text>
        <Text variant="body-sm">{RoleLabel?.[data?.role] || '-'}</Text>

        {!!badgeStatus && (
          <div className="mt-0.5">
            <SchoolItemBadge status={badgeStatus} />
          </div>
        )}
      </div>

      <Button
        disabled={disabled}
        variant="ghost"
        color="white"
        className={clsx(
          '!rounded-full',
          disabled ? '!outline-icon-disabled' : '!outline-gray-30'
        )}
        iconOnly
        onClick={onClick}
      >
        <Icon color={disabled ? 'disabled' : 'informational'}>
          chevron_right
        </Icon>
      </Button>
    </div>
  )
}
export default SchoolItem
